import { BaseSvg } from './BaseSvg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContactSvg = () => {
  return /*#__PURE__*/_jsxs(BaseSvg, {
    name: "Contact",
    size: "70%",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M107.154 124.03C130.886 124.031 150.186 143.201 150.188 166.778C150.188 169.729 147.776 172.124 144.806 172.125C141.836 172.124 139.429 169.729 139.429 166.778C139.428 149.104 124.945 134.714 107.154 134.714C89.3628 134.714 74.8798 149.104 74.8786 166.778C74.8786 169.729 72.4719 172.124 69.5018 172.125C66.5311 172.125 64.125 169.73 64.125 166.778C64.1261 143.201 83.4213 124.031 107.154 124.03Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M107.159 43.875C126.466 43.8771 142.117 59.4286 142.117 78.6108C142.116 97.7924 126.466 113.34 107.159 113.342C87.8496 113.342 72.1963 97.7936 72.195 78.6108C72.1956 59.4273 87.8492 43.875 107.159 43.875ZM107.159 54.5585C93.7907 54.5585 82.9492 65.3301 82.9486 78.6108C82.9499 91.8909 93.7911 102.658 107.159 102.658C120.524 102.656 131.363 91.8896 131.364 78.6108C131.363 65.3314 120.525 54.5606 107.159 54.5585Z"
    })]
  });
};